// extracted by mini-css-extract-plugin
export default {"cameraWrapper":"winter_cameraWrapper__HdWDj","centeredImage":"winter_centeredImage__XQi4Z"};